/**
 * Is a product eligible for ABO?
 *
 * @param {Object} productData - Raw product data
 * @returns {boolean}
 */
export default function isAboProduct(productData) {
  return productData?.priceinformation?.[0]?.abo_price > 0
}
